/**
 * @generated SignedSource<<ec60e0c012dbd60409f644bfda9d2edc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LogoutInput = {
  clientMutationId?: string | null;
};
export type AuthScreenBase_LogoutMutation$variables = {
  input: LogoutInput;
};
export type AuthScreenBase_LogoutMutation$data = {
  readonly InfectopharmAuth: {
    readonly logout: {
      readonly clientMutationId: string | null;
    } | null;
  };
};
export type AuthScreenBase_LogoutMutation = {
  response: AuthScreenBase_LogoutMutation$data;
  variables: AuthScreenBase_LogoutMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "InfectopharmAuthMutations",
    "kind": "LinkedField",
    "name": "InfectopharmAuth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "LogoutPayload",
        "kind": "LinkedField",
        "name": "logout",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthScreenBase_LogoutMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AuthScreenBase_LogoutMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3af6804186794130a24bc8e0c360937e",
    "id": null,
    "metadata": {},
    "name": "AuthScreenBase_LogoutMutation",
    "operationKind": "mutation",
    "text": "mutation AuthScreenBase_LogoutMutation(\n  $input: LogoutInput!\n) {\n  InfectopharmAuth {\n    logout(input: $input) {\n      clientMutationId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3f0bd2f22fcdb38f0f5dac3ee35e7b17";

export default node;
